var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.multPmts, function (n, index) {
        return _c(
          "b-row",
          { key: index, staticClass: "py-1" },
          [
            index === _vm.multPmts.length - 1
              ? _c(
                  "b-col",
                  { attrs: { sm: "6" } },
                  [
                    _c("form-read-group-label-input", {
                      attrs: {
                        isMandatory: "",
                        type: "number",
                        inputLabel: _vm.$t("common.amnt"),
                        placeholderValue: "Amount (" + _vm.ccy + ")",
                        inputValue: parseFloat(
                          parseFloat(n.amount).toFixed(2)
                        ).toString(),
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "b-col",
                  { attrs: { sm: "6" } },
                  [
                    _c("form-write-group-label-input", {
                      attrs: {
                        isMandatory: "",
                        inputType: "number",
                        inputLabel: _vm.$t("common.amnt"),
                        placeholderValue:
                          _vm.$t("common.amnt") + " (" + _vm.ccy + ")",
                      },
                      model: {
                        value: n.amount,
                        callback: function ($$v) {
                          _vm.$set(n, "amount", $$v)
                        },
                        expression: "n.amount",
                      },
                    }),
                  ],
                  1
                ),
            _vm._v(" "),
            index === _vm.multPmts.length - 1
              ? _c(
                  "b-col",
                  { attrs: { sm: "6" } },
                  [
                    _c("form-write-group-label-input", {
                      attrs: {
                        isMandatory: "",
                        disabled: "",
                        inputType: "date",
                        disablePastDates: "",
                        disableFromDate: _vm.execDate,
                        id: "negotiationDateInput" + index,
                        inputLabel: _vm.$t("common.date_label"),
                        placeholderValue: _vm.$t("common.slct_date"),
                      },
                      model: {
                        value: n.date,
                        callback: function ($$v) {
                          _vm.$set(n, "date", $$v)
                        },
                        expression: "n.date",
                      },
                    }),
                  ],
                  1
                )
              : _c(
                  "b-col",
                  { attrs: { sm: "6" } },
                  [
                    _c("form-write-group-label-input", {
                      attrs: {
                        isMandatory: "",
                        inputType: "date",
                        disablePastDates: "",
                        disableFromDate: _vm.execDate,
                        id: "negotiationDateInput" + index,
                        inputLabel: _vm.$t("common.date_label"),
                        placeholderValue: _vm.$t("common.slct_date"),
                      },
                      model: {
                        value: n.date,
                        callback: function ($$v) {
                          _vm.$set(n, "date", $$v)
                        },
                        expression: "n.date",
                      },
                    }),
                  ],
                  1
                ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "form-group row justify-content-end" },
        [
          _c("b-col", { attrs: { cols: "8" } }, [
            _c(
              "div",
              { staticClass: "text-right font-weight-bold fs-12px w-100" },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("regles_metier.rqstng")) + " "
                ),
                _c("font", { attrs: { color: _vm.sumColor } }, [
                  _vm._v(_vm._s(_vm.sum + _vm.ccy)),
                ]),
                _vm._v(" " + _vm._s(_vm.$t("common.of_label")) + "\n        "),
                _vm._v(" "),
                _c("font", { attrs: { color: "#12bcf1" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.amount == "" ? "0" + _vm.ccy : _vm.amount + _vm.ccy
                    )
                  ),
                ]),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }